const ROOT_PATH = '/push-notifications';

export const PushNotificationsPaths = {
  ROOT_PATH,
} as const;
